<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     合作伙伴标签
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="partner-tag" :class="{ 'sm': size === 'sm', 'lg': size === 'lg', 'hover': hover }">
    <div class="flex align-items-center">
      <div class="hd bg-blue text-white pl-xs pr-xs" :class="{'pl-xxs pr-xxs': size === 'sm'}">{{ partnerLevelObj[partner.level] }}</div>
      <div v-if="nameShow" class="ft text-blue pl-sm pr-sm" :class="{'pl-xs pr-xs': size === 'sm', 'block': type === 'complex'}">
        <span class="tag-name">{{ partner.name }}</span>
        <span class="tag-icon iconfont icon-customer">
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PartnerTag',

  components: {
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    nameShow: {
      type: Boolean,
      default: true
    },

    hover: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: '' // sm, lg
    },

    type: {
      type: String,
      default: 'simple' // complex
    },

    partner: {
      type: Object,
      default() {
        return {
          level: 1,
          name: ''
        }
      }
    },
  },

  data() {
    return {
    }
  },

  computed: {
    partnerLevelObj(state) {
      return this.$store.getters.partnerLevelObj
    },
  },

  created() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.partner-tag {
  display: inline-block;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  border: 1px solid #409eff;
  box-sizing: content-box !important;
  .tag-icon {
    font-size: 16px;
    line-height: 24px;
  }
  &.sm {
    border-radius: 3px;
    font-size: 14px;
    height: 18px;
    line-height: 18px;
    .tag-icon {
      font-size: 14px;
      line-height: 18px;
    }
  }
  &.lg {
    border-radius: 5px;
    font-size: 16px;
    height: 28px;
    line-height: 28px;
  }
  &.hover {
    .tag-name {
      display: none;
    }
    .tag-icon {
      display: block;
    }
    &:hover {
      .tag-name {
        display: block;
      }
      .tag-icon {
        display: none;
      }
    }
  }
  .block {
    .tag-name {
      display: block;
    }
    .tag-icon {
      display: none;
    }
  }
}
</style>